<template>
	<v-card 
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>

		<v-card-text>
			{{ text }}
		</v-card-text>
		
		<v-card-text>
			<v-form ref="form">
				<v-row dense>
					<v-col cols="12">
						<v-text-field
							v-model="claim.applicant.name"
							label="Прізвище, ім'я, по батькові"
							placeholder="Іваненко Іван Іванович"
							variant="outlined"
							:rules="[rules.required]"
							@keydown.ctrl.z="item.ApplicantName='Іваненко Іван Іванович'"
						></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field
							v-model="claim.applicant.phone"
							label="Нормер телефону"
							placeholder="+38 ХХХ ХХХ ХХ ХХ"
							variant="outlined"
							:rules="[rules.required,rules.phone]"
							@keydown.ctrl.z="item.ApplicantPhone='+380963332211'"
						></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field
							v-model="claim.applicant.email"
							label="E-mail"
							placeholder="example@mail.com"
							variant="outlined"
							:rules="[rules.required,rules.email]"
							@keydown.ctrl.z="item.ApplicantEmail='example@mail.com'"
						></v-text-field>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import mixin from './mixin/main'

export default {
	mixins: [mixin],
}
</script>
